import { Fragment, useState } from "react";
import { Dialog, Transition, Switch, Listbox } from "@headlessui/react";
import {
  // ExclamationCircleIcon,
  CheckIcon,
  SelectorIcon,
} from "@heroicons/react/solid";

const positions = [
  { name: "For", id: "FOR" },
  { name: "Against", id: "AGAINST" },
  { name: "Undecided", id: "UNDECIDED" },
  { name: "No Stance", id: "NO STANCE" },
];

const SpeakerModal = ({ show, visible, topic }) => {
  const [user, setUser] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    addressPrimary: "",
    addressSecondary: "",
    city: "",
    state: "",
    zipCode: "",
    attending: true,
    speaking: false,
    comment: "",
    representingOrg: "",
  });
  const [selected, setSelected] = useState(positions[3]);

  function change(key, value) {
    setUser({
      ...user,
      [key]: value,
    });
  }

  function handleSubmit() {
    let updatedUser = Object.assign({}, user);
    updatedUser.position = selected.id;
    updatedUser.name = user.name?.length > 0 ? user.name : "Anonymous";
    visible("submit", updatedUser, topic.id);
  }

  // function validateEmail(email) {
  //   const res =
  //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //   return res.test(String(email).toLowerCase());
  // }

  return (
    <Transition show={show} as={Fragment}>
      <Dialog
        as="div"
        id="modal"
        className="fixed inset-0 z-10 overflow-y-auto"
        static
        open={show}
        onClose={() => visible("cancel")}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-200 opacity-80" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-lg md:max-w-2xl lg:max-w-4xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl rounded-2xl border border-gray-200">
              <Dialog.Title as="h3" className="text-lg leading-6 text-gray-900">
                <p className="font-light italic">Public Registration</p>
                <p className="font-medium">{topic.title}</p>
              </Dialog.Title>
              <div className="mt-2 flex flex-col lg:flex-row">
                <div className="flex-grow space-y-6">
                  <div className="mt-6 grid grid-cols-2 gap-2 lg:gap-4">
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="full_name"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Full Name
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          name="full_name"
                          id="name"
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                          value={user.name}
                          onChange={(e) => change(e.target.id, e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Email
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="email"
                          name="email"
                          id="email"
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                          value={user.email}
                          onChange={(e) => change(e.target.id, e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="title"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Address
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          name="title"
                          id="addressPrimary"
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                          value={user.addressPrimary}
                          onChange={(e) => change(e.target.id, e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="title"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Address 2
                      </label>
                      <input
                        type="text"
                        name="title"
                        id="addressSecondary"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                        value={user.addressSecondary}
                        onChange={(e) => change(e.target.id, e.target.value)}
                      />
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="title"
                        className="block text-sm font-medium text-gray-700"
                      >
                        City
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          name="title"
                          id="city"
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                          value={user.city}
                          onChange={(e) => change(e.target.id, e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="title"
                        className="block text-sm font-medium text-gray-700"
                      >
                        State
                      </label>
                      <input
                        type="text"
                        name="title"
                        id="state"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                        value={user.state}
                        onChange={(e) => change(e.target.id, e.target.value)}
                      />
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="title"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Zip Code
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          name="title"
                          id="zipCode"
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                          value={user.zipCode}
                          onChange={(e) => change(e.target.id, e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="title"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Phone Number
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          name="title"
                          id="phoneNumber"
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                          value={user.phoneNumber}
                          onChange={(e) => change(e.target.id, e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <div className="flex justify-between items-center">
                        <div>
                          <label
                            htmlFor="title"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Speaking?
                          </label>
                          <Switch
                            checked={user.speaking}
                            onChange={(e) => change("speaking", e)}
                            className={`${
                              user.speaking ? "bg-blue-600" : "bg-gray-400"
                            } relative inline-flex items-center h-6 rounded-full w-11 mt-2`}
                          >
                            <span className="sr-only">
                              Enable notifications
                            </span>
                            <span
                              className={`${
                                user.speaking
                                  ? "translate-x-6"
                                  : "translate-x-1"
                              } inline-block w-4 h-4 transform bg-white rounded-full`}
                            />
                          </Switch>
                        </div>
                        {user.speaking && (
                          <div>
                            <label
                              htmlFor="title"
                              className="block text-sm font-medium text-gray-700"
                            >
                              In-Person
                            </label>
                            <Switch
                              checked={user.attending}
                              onChange={(e) => change("attending", e)}
                              className={`${
                                user.attending ? "bg-blue-600" : "bg-gray-400"
                              } relative inline-flex items-center h-6 rounded-full w-11 mt-2`}
                            >
                              <span className="sr-only">
                                Enable notifications
                              </span>
                              <span
                                className={`${
                                  user.attending
                                    ? "translate-x-6"
                                    : "translate-x-1"
                                } inline-block w-4 h-4 transform bg-white rounded-full`}
                              />
                            </Switch>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="position"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Position
                      </label>
                      <Listbox value={selected} onChange={setSelected}>
                        {({ open }) => (
                          <>
                            <div className="relative mt-1">
                              <Listbox.Button className=" border border-gray-300 relative w-full py-2 pl-3 pr-10 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm">
                                <span className="block truncate">
                                  {selected.name}
                                </span>
                                <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                  <SelectorIcon
                                    className="w-5 h-5 text-gray-400"
                                    aria-hidden="true"
                                  />
                                </span>
                              </Listbox.Button>
                              <Transition
                                show={open}
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                              >
                                <Listbox.Options
                                  static
                                  className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                                >
                                  {positions.map((person, personIdx) => (
                                    <Listbox.Option
                                      key={personIdx}
                                      className={({ active }) =>
                                        `${
                                          active
                                            ? "text-amber-900 bg-amber-100"
                                            : "text-gray-900"
                                        }
                          cursor-default select-none relative py-2 pl-10 pr-4`
                                      }
                                      value={person}
                                    >
                                      {({ selected, active }) => (
                                        <>
                                          <span
                                            className={`${
                                              selected
                                                ? "font-medium"
                                                : "font-normal"
                                            } block truncate`}
                                          >
                                            {person.name}
                                          </span>
                                          {selected ? (
                                            <span
                                              className={`${
                                                active
                                                  ? "text-amber-600"
                                                  : "text-amber-600"
                                              }
                                absolute inset-y-0 left-0 flex items-center pl-3`}
                                            >
                                              <CheckIcon
                                                className="w-5 h-5"
                                                aria-hidden="true"
                                              />
                                            </span>
                                          ) : null}
                                        </>
                                      )}
                                    </Listbox.Option>
                                  ))}
                                </Listbox.Options>
                              </Transition>
                            </div>
                          </>
                        )}
                      </Listbox>
                    </div>
                    <div className="col-span-2">
                      <label
                        htmlFor="title"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Representing Org.
                      </label>
                      <input
                        name="representingOrg"
                        id="representingOrg"
                        type="text"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                        value={user.representingOrg}
                        onChange={(e) =>
                          change("representingOrg", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-span-2">
                      <label
                        htmlFor="title"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Comment
                      </label>
                      <textarea
                        name="title"
                        id="comment"
                        rows="4"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                        value={user.comment}
                        onChange={(e) => change("comment", e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4 flex justify-between">
                <button
                  type="button"
                  className="inline-flex justify-center px-4 py-2 text-sm font-medium text-reed-900 bg-red-100 border border-transparent rounded-md hover:bg-red-200 focus:outline-none transform duration-200"
                  onClick={() => visible("cancel")}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none transform duration-200"
                  onClick={() => handleSubmit()}
                >
                  Submit
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default SpeakerModal;
